;
( function( $, window, document, undefined )
{
    'use strict';

    var footer = function( options )
    {
        this.init();
    };

    footer.prototype = {

        init : function()
        {
            $('#footer-looking').click(function (e) {
                e.preventDefault();

                $(this).parent().toggleClass('expanded');
            });

            $( '#current-language' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                if( !this.$selector )
                {
                    this.$selector = $( '#language-selector' );
                }

                this.$selector.toggleClass( 'opened' );

                $.fn.SiteCatalyst( 'track', 'Show flag select', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'button:flag:trigger:%pageName%',
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );

            $( '#back-to-top' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                if( !this.t )
                {
                    this.t = $( 'html, body' );
                }

                this.t.animate( {
                    scrollTop : 0
                }, 500, 'easeInCubic' );
            } );
        }

    };

    $.fn.footer = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'footer' );

        if( !instance )
        {
            instance = new footer( this, options );
            $item.data( 'footer', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );
